"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendSantanderApplicationMutation = void 0;
const types_1 = require("../../types");
exports.sendSantanderApplicationMutation = `
  mutation sendApplication($input: ApplicationInput!, $financeProvider: Int) {
    sendApplication(input: $input, financeProvider: $financeProvider) {
      ${types_1.applicationNestedFields}
    }
  }
`;
//# sourceMappingURL=application.js.map